import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import { Box, Button } from '@mui/material'

const OrganizationsHeader = () => {
  const navigate = useNavigate()

  return (
        <Box id='titleAdd' sx={{ ml: '-2vw', mt: '0.5vh' }}>
            <Button variant="contained" size='large' onClick={() => navigate('/search')}> <ArrowBackIosNewRoundedIcon/>
            </Button>
        </Box>
  )
}
export default OrganizationsHeader
